import type { IBillLastOperatorQry, IDisableTransferBillCmd, IEnableTransferBillCmd } from "@/data/commands/bill/IEnableTransferBillCmd";
import type { ITransferBillCmd } from "@/data/commands/bill/TransferBillCmd";



import { BaseServiceDao } from "./BaseServiceDao";
import type { IBillLastOperator } from "@/data/model/Bill";


export class BillDao extends BaseServiceDao {
    public static className = "BillDao";

    constructor() {
        super("bill");
        this.isLocationDependent = true;
    }

    public async transferBill(cmd: ITransferBillCmd): Promise<void> {
        return this.put(`${cmd.sourceBillId}/transfer-bill-items`, cmd);
    }

    public async enableTransferBillItems(cmd: IEnableTransferBillCmd): Promise<void> {
        return this.put(`${cmd.billId}/enable-transfer-bill-items`, cmd);
    }

    public async disableTransferBillItems(cmd: IDisableTransferBillCmd): Promise<void> {
        return this.put(`${cmd.billId}/disable-transfer-bill-items`, cmd);
    }

    public async getBillLastOperator(cmd: IBillLastOperatorQry): Promise<IBillLastOperator | undefined> {
        return this.get(`${cmd.billId}/last-operator`, cmd, BillDao.parseBillLastOperator);
    }

    public static parseBillLastOperator(literal: any): IBillLastOperator | undefined {
        if (literal == null) {
            return undefined;
        } else {
            return {
                identityId: literal.identityId,
                name: literal.name,
            }
        }
    }
}
